var _mask, _path, _path2, _path3, _circle, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 205,
    viewBox: "0 0 312 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3063_1105",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    stroke: "#F6F6F6",
    strokeWidth: 10,
    mask: "url(#path-1-outside-1_3063_1105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 197.846C5.41082 175.526 4.27956 152.026 8.50606 129.195C12.7326 106.365 22.2014 84.8269 36.167 66.2778C50.1326 47.7287 68.2136 32.6749 88.9862 22.3018C109.759 11.9287 132.656 6.51945 155.875 6.50005L155.917 56.7009C140.469 56.7138 125.235 60.3127 111.414 67.2142C97.5932 74.1157 85.5634 84.1314 76.2718 96.4727C66.9801 108.814 60.6802 123.144 57.8682 138.334C55.0562 153.523 55.8088 169.159 60.0669 184.008L11.8107 197.846Z",
    fill: "#E8D313"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 160.5,
    r: 23,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.699 175.753C151.27 177.924 142.713 172.978 140.585 164.711C138.456 156.442 117.26 10.9293 117.26 10.9293C117.26 10.9293 168.976 148.584 171.105 156.853C173.233 165.12 168.125 173.584 159.699 175.753Z",
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "matrix(0.968413 -0.24935 -0.24935 -0.968413 150.018 170.295)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMr);
export default __webpack_public_path__ + "static/media/img_mr.6b502e881f8988c1d4d6e2d2563f622f.svg";
export { ForwardRef as ReactComponent };